(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6981],{

/***/ 94075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Category; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./components/shared/PaginatedArticles.tsx
var PaginatedArticles = __webpack_require__(3149);
// EXTERNAL MODULE: ./components/shared/QuickLinks.tsx
var QuickLinks = __webpack_require__(87160);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/category/SoftwareQuickLinks.tsx
 // import PropTypes from 'prop-types'




function SoftwareQuickLinks(_ref) {
  var softwares = _ref.softwares;
  if (!softwares) return null;
  var title = '';
  var linkList = [];
  title = 'Related Softwares';
  softwares.forEach(function (software) {
    var _software$attributes = software.attributes,
        slug = _software$attributes.slug,
        name = _software$attributes.name;
    linkList.push({
      href: '/software/[slug]',
      as: "/software/".concat(slug),
      linkText: " ".concat(name, " Review")
    });
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    style: {
      marginBottom: '16px'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      span: 24,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
        title: title,
        linkList: linkList
      })
    })
  });
} // SoftwareQuickLinks.propTypes = {
//   softwares: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string,
//       slug: PropTypes.string,
//     })
//   ).isRequired,
// }
;// CONCATENATED MODULE: ./components/category/RelatedCategories.tsx




function RelatedCategories(_ref) {
  var relatedCategories = _ref.relatedCategories;
  if (!relatedCategories) return null;
  var title = '';
  var linkList = [];
  title = 'Related Categories';
  relatedCategories.forEach(function (category) {
    var slug = category.slug,
        name = category.name;
    linkList.push({
      href: '/faqs/[slug]',
      as: "/faqs/".concat(slug),
      linkText: " ".concat(name, " ")
    });
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    style: {
      marginBottom: '16px'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      span: 24,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
        title: title,
        linkList: linkList
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/category/CategoryFaq.tsx
 // import PropTypes from 'prop-types'







function CategoryFAQ(_ref) {
  var category = _ref.category;
  var _category$attributes = category.attributes,
      articles = _category$attributes.articles,
      categoriesArticlesCount = _category$attributes.categoriesArticlesCount,
      softwares = _category$attributes.softwares,
      relatedCategories = _category$attributes.relatedCategories;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper page",
    gutter: [16, 16],
    style: {
      width: '100%',
      padding: '16px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      md: 16,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        style: {
          width: '100%'
        },
        children: articles.data.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(PaginatedArticles/* default */.Z, {
          articles: articles.data,
          count: categoriesArticlesCount,
          type: "category"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          children: " No FAQs Found "
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 8,
      style: {
        marginTop: 16
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RelatedCategories, {
        relatedCategories: relatedCategories
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SoftwareQuickLinks, {
        softwares: softwares.data
      })]
    })]
  });
} // CategoryFAQ.propTypes = {
//   category: PropTypes.shape({
//     name: PropTypes.string.isRequired,
//     articles: PropTypes.arrayOf(
//       PropTypes.shape({
//         title: PropTypes.string.isRequired,
//         slug: PropTypes.string.isRequired,
//         description: PropTypes.string.isRequired,
//       }).isRequired
//     ).isRequired,
//     categoriesArticlesCount: PropTypes.number.isRequired,
//   }).isRequired,
// }
// EXTERNAL MODULE: ./components/shared/schema/article.tsx
var article = __webpack_require__(28262);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./pages/faqs/[slug]/[[...page]].tsx










var title = function title(_ref) {
  var category = _ref.category,
      page = _ref.page;
  return "Frequently asked questions about ".concat(category.attributes.name, " - Page ").concat(page || 1);
};

var description = function description(_ref2) {
  var category = _ref2.category;
  return "All the finance related frequently asked questions(FAQs) and answers about ".concat(category.attributes.name);
};

var __N_SSP = true;
function Category(props) {
  var router = (0,next_router.useRouter)();
  var page = router.query.page;
  var asPath = router.asPath,
      slug = router.query.slug;
  var data = props.data;
  var categories = data.categories,
      allBrokers = data.all_brokers,
      navCalculators = data.nav_calculators,
      allPages = data.all_pages;
  var category = categories.data[0];
  var pageTitle = title({
    category: category,
    page: page
  });
  var pageDescription = description({
    category: category
  });
  var urlWithoutPage = (0,util/* pageUri */.TI)("/faqs/".concat(slug));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers.data,
    navCalculators: navCalculators.data,
    allPages: allPages.data,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: pageTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: pageDescription
      }), page === '1' && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: urlWithoutPage
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(article/* ArticleJsonLd */.d, {
      url: (0,util/* pageUri */.TI)(asPath),
      title: pageTitle,
      description: pageDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryFAQ, {
      category: category
    })]
  });
}

/***/ }),

/***/ 59589:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs/[slug]/[[...page]]",
      function () {
        return __webpack_require__(94075);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,7527,6873,3679,5045,2841,8182,1997,9774,2888,179], function() { return __webpack_exec__(59589); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);